import React from 'react';
export type PillTabItem = {
  id: string;
  label: string;
  /** Optional brand logo URL, rendered to the left of the label. */
  logo?: string;
  ariaLabel?: string;
};
/**
 * The small, quiet segmented control used across /alt. Deliberately lighter
 * than the page's pillar navigation: these are local controls, so they sit in
 * a single bordered pill with the active item filled in ink.
 *
 * `value` may be null when the surface is in a state no tab represents (for
 * example the architecture diagram after individual blocks were toggled).
 */
export function PillTabs({
  items,
  value,
  onChange,
  ariaLabel,
  className = ''
}: {
  items: PillTabItem[];
  value: string | null;
  onChange: (id: string) => void;
  ariaLabel: string;
  className?: string;
}) {
  return <div className={`inline-flex flex-wrap items-center justify-center gap-1.5 rounded-full border border-[#EFEAE1] bg-white p-1 ${className}`} role="tablist" aria-label={ariaLabel} data-id="element-358" data-mp="11jn6tkhq2lll">
      {items.map(item => {
      const active = item.id === value;
      return <button key={item.id} type="button" role="tab" aria-selected={active} aria-label={item.ariaLabel} onClick={() => onChange(item.id)} className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[13px] font-semibold transition-colors ${active ? 'bg-[#2B211A] text-white' : 'text-[#6B5D52] hover:bg-[#F6F2EA]'}`} data-id="element-359" data-mp="1z7khqw788gu5">
            {item.logo && <img src={item.logo} alt="" aria-hidden="true" className="size-[15px] shrink-0 object-contain" data-id="element-360" data-mp="2hxabdfz96wkh" />}
            {item.label}
          </button>;
    })}
    </div>;
}